import script from "./DGFYToken.vue?vue&type=script&setup=true&lang=js"
export * from "./DGFYToken.vue?vue&type=script&setup=true&lang=js"

import "./DGFYToken.vue?vue&type=style&index=0&id=cead43ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cead43ec"]])

export default __exports__